import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { createAppRouter } from './router.js';
import { queryClient } from './resources/query-client.js';
import { registerServiceWorker } from './lib/service-worker.js';
import './i18n/i18n.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

const router = createAppRouter(queryClient);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void registerServiceWorker().catch((err) => {
      console.error('Service worker registration failed', err);
    });
  });
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
